// Printable QR card: event name, date/time, the QR, and the short URL. Offers
// SVG and PNG download and a clean print (see styles/print.css).

import { formatDateTime } from '../lib/format';
import { qrPngDataUrl, qrSvg } from '../lib/qr';

function download(filename: string, href: string): void {
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function slug(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'event';
}

// Builds a self-contained card element for the given event.
export function buildQrCard(opts: {
  name: string;
  start?: string;
  publicUrl: string;
}): HTMLElement {
  const card = document.createElement('div');
  card.className = 'qr-card';

  const title = document.createElement('h3');
  title.className = 'qr-card-title';
  title.textContent = opts.name;
  card.appendChild(title);

  if (opts.start) {
    const when = document.createElement('p');
    when.className = 'qr-card-when';
    when.textContent = formatDateTime(opts.start);
    card.appendChild(when);
  }

  const qrWrap = document.createElement('div');
  qrWrap.className = 'qr-card-qr';
  qrWrap.innerHTML = qrSvg(opts.publicUrl, 240);
  card.appendChild(qrWrap);

  const url = document.createElement('p');
  url.className = 'qr-card-url';
  url.textContent = opts.publicUrl.replace(/^https?:\/\//, '');
  card.appendChild(url);

  const actions = document.createElement('div');
  actions.className = 'qr-card-actions no-print';

  const svgBtn = document.createElement('button');
  svgBtn.type = 'button';
  svgBtn.className = 'btn small';
  svgBtn.textContent = 'Download SVG';
  svgBtn.addEventListener('click', () => {
    const blob = new Blob([qrSvg(opts.publicUrl, 512)], { type: 'image/svg+xml' });
    const href = URL.createObjectURL(blob);
    download(`${slug(opts.name)}-qr.svg`, href);
    setTimeout(() => URL.revokeObjectURL(href), 1000);
  });

  const pngBtn = document.createElement('button');
  pngBtn.type = 'button';
  pngBtn.className = 'btn small';
  pngBtn.textContent = 'Download PNG';
  pngBtn.addEventListener('click', () => {
    download(`${slug(opts.name)}-qr.png`, qrPngDataUrl(opts.publicUrl, 1024));
  });

  const printBtn = document.createElement('button');
  printBtn.type = 'button';
  printBtn.className = 'btn small';
  printBtn.textContent = 'Print';
  printBtn.addEventListener('click', () => {
    document.body.classList.add('printing-qr');
    card.classList.add('print-target');
    const cleanup = () => {
      document.body.classList.remove('printing-qr');
      card.classList.remove('print-target');
      window.removeEventListener('afterprint', cleanup);
    };
    window.addEventListener('afterprint', cleanup);
    window.print();
  });

  actions.append(svgBtn, pngBtn, printBtn);
  card.appendChild(actions);

  return card;
}
